module.exports = __webpack_public_path__ + "media/images/icons/material/download-circle-a5e097dc684189801edd616409d9e541.svg";